import { FormlyFieldConfig } from "@ngx-formly/core";

export function invalidOdometerValueValidator(field: FormlyFieldConfig) {
    const formControl = field.parent as any;  // Get the current model
    const odometerStart = formControl?.get('odometerStart')?.value;
    const odometerEnd = formControl?.get('odometerEnd')?.value;

    if (odometerStart !== null && odometerEnd !== null) {
        return odometerEnd >= odometerStart ? null : { invalidOdometerValue: true };
    }

    return null;
}

